import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { A11yModule } from '@angular/cdk/a11y';

import { PhonebookSidebarComponent } from './components/phonebook-sidebar/phonebook-sidebar.component';
import { ContactFormDialogComponent } from './components/contact-form-dialog/contact-form-dialog.component';
import { DeleteConfirmDialogComponent } from './components/delete-confirm-dialog/delete-confirm-dialog.component';
import { ToastComponent } from './components/toast/toast.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { JoinTruthyPipe } from './pipes/join-truthy.pipe';
import { CorporateFormsService } from '../services/corporate-forms.service';
import { AutosaveStatusComponent } from 'src/app/shared/form-drafts/autosave-status.component';

@NgModule({
  declarations: [
    PhonebookSidebarComponent,
    ContactFormDialogComponent,
    DeleteConfirmDialogComponent,
    ToastComponent,
    SearchableSelectComponent,
    JoinTruthyPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    A11yModule,
    AutosaveStatusComponent,
  ],
  exports: [
    PhonebookSidebarComponent,
    ToastComponent,
  ],
  providers: [
    CorporateFormsService,
  ],
})
export class PhonebookModule {}
